<app-navbar-style-two></app-navbar-style-two>

<section class="hosbay-section">
    <div class="container">
        <div class="cta-section">
            <h1 i18n>Connect with MEDEIL – Retail & Pharmacy POS Experts</h1>
            <p i18n>Have questions about MEDEIL’s retail or pharmacy POS solutions? Need expert POS support or want to request a demo? Our team is here to help you succeed. Whether you’re looking for product information, POS customer service, or want to explore a partnership, contact MEDEIL today and get the assistance your business needs.</p>
        </div>
    </div>
</section>

<section class="hosbay-section">
    <div class="container">
        <div class="cta-section">
            <h2 i18n>Partnership and Business Inquiries</h2>
            <p i18n>Interested in partnering with MEDEIL or have a business inquiry? We welcome collaboration opportunities with resellers, technology partners, and industry leaders. Fill out the MEDEIL contact form below or email us directly to discuss how we can work together to deliver innovative POS solutions for retail and pharmacy businesses</p>
        </div>
    </div>
</section>
<br>

<div class="contain">
    <div class="container">
        <h2 i18n style="color: white;">Office Locations and Contact Details</h2>
        <p i18n style="color: white;">Reach out to our global offices for POS support, retail POS help, or pharmacy POS assistance. Our dedicated customer service team is ready to answer your questions and provide prompt assistance.</p>
    </div>
</div>

<div class="contact-area">
    <div class="container">
        <div class="contact-max">
            <div class="row">
                <div class="col-lg-4 col-md-6">
                    <div class="contact-card">
                        <i class="flaticon-position"></i>
                        <h3 i18n>Vanuston Intelligence Private Limited<br>
                            No 22, Bazaar Road, Saidapet,<br>
                            Chennai – 600075, <br>
                            Tamil Nadu,<br>
                            India - 600075.</h3>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6">
                    <div class="contact-card">
                        <i class="flaticon-email"></i>
                        <h3><a href="mailto:info@vanuston.com">E-mail: info&#64;vanuston.com</a></h3>
                        <!-- <h3><a href="mailto:support@pilar.com">Email:support&#64;pilar.com</a></h3> -->
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 offset-md-3 offset-lg-0">
                    <div class="contact-card">
                        <i class="flaticon-to-do-list"></i>
                        <h3><a href="tel:+91-44-42119714">Telefone: +91-44-42119714</a></h3>
                        <h3><a href="tel:+91-8680008895 ">Mob: +91-8680008895 </a></h3>
                        <h3><a href="tel:+91- 9566124105 ">Mob: +91- 9566124105 </a></h3>

                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="contain">
    <div class="container">
        <h3 i18n style="color: white;">Contact MEDEIL Today</h3>
        <p i18n style="color: white;">Complete the MEDEIL contact form below for POS demo requests, product support, or any other inquiries. Our team will respond promptly to help your business grow with the right POS solutions.</p>
    </div>
</div>


<div class="contact-map">
    <div class="container-fluid m-0 p-0">
        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d735257.9205168115!2d-75.33502765384733!3d40.30050562979537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x2a07dcfd9d0ce20e!2sUs%20Rt%2040%20%40%20Governors%20Sq%20Plaza%202!5e0!3m2!1sen!2sbd!4v1596709319151!5m2!1sen!2sbd"></iframe>

        <div class="contact-wrap">
            <div class="contact-form">
                <span i18n>SEND MESSAGE</span>
                <h2 i18n>Contact With Us</h2>

                <form id="contactForm">
                    <div class="row">
                        <div class="col-lg-6 col-sm-6">
                            <div class="form-group">
                                <i class='bx bx-user'></i>
                                <input type="text" name="name" id="name" class="form-control" required placeholder="Your Name*" formControlName="username" (keypress)="allowOnlyLetters($event)">
                            </div>
                        </div>

                        <div class="col-lg-6 col-sm-6">
                            <div class="form-group">
                                <i class='bx bx-user'></i>
                                <input type="email" name="email" id="email" class="form-control" required placeholder="E-mail*" formControlName="useremail" (keypress)="allowOnlyEmailCharacters($event)">
                            </div>
                        </div>

                        <div class="col-lg-6 col-sm-6">
                            <div class="form-group">
                                <i class='bx bx-phone'></i>
                                <input type="text" name="phone_number" id="phone_number" required class="form-control" placeholder="Your Phone" formControlName="mobilenumber" (keypress)="allowOnlyNumbers($event)">
                            </div>
                        </div>

                        <div class="col-lg-6 col-sm-6">
                            <div class="form-group">
                                <i class='bx bx-file'></i>
                                <input type="text" name="msg_subject" id="msg_subject" class="form-control" required placeholder="Your Subject" formControlName="msgsuubject" >
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12">
                            <div class="form-group">
                                <i class='bx bx-envelope'></i>
                                <textarea name="message" class="form-control" id="message" cols="30" rows="8" required placeholder="Your Message" formControlName="message"></textarea>
                            </div>
                        </div>

                        <div class="col-lg-12 col-md-12 text-end">
                            <button type="submit" class="default-btn border-radius" (click)="sendmsg()" i18n>Send Message <i class='bx bx-plus'></i></button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

<app-footer-style-two></app-footer-style-two>